import { render, staticRenderFns } from "./DynamicConfirm.vue?vue&type=template&id=52a499e2&"
import script from "./DynamicConfirm.vue?vue&type=script&lang=js&"
export * from "./DynamicConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports